import styled, { CSSObject } from 'styled-components';
import { ColorEnum } from './types';

interface TagStyledProps {
  color?: string;
}

const TagStyled = styled.div<TagStyledProps>(({ theme, color }) => {
  const styleSheet: CSSObject = {
    boxSizing: 'border-box',
    display: 'inline-flex',
    borderRadius: 160,
    padding: `${theme.space[1]} ${theme.space[4]}`,
    border: `1px solid ${theme.color.primary}`,
    background: theme.color[color],
    color: theme.color.wfWhite,
    fontSize: theme.font.size.xsmall,
    lineHeight: theme.font.size.xsmall,
    fontWeight: theme.font.weight.normal,
  };

  if (color === ColorEnum.transparent) {
    styleSheet.color = theme.color.primary;
    styleSheet.background = 'transparent';
  }

  return styleSheet;
});

export { TagStyled };
